<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100vh;
}

.app_scan {
  width: 200px;
  height: 60px;
  background-color: red;
  border-radius: 30px;
  margin: 0 auto;
  margin-top: 100px;
}
</style>
